import { render, staticRenderFns } from "./VmcUpsell.vue?vue&type=template&id=6df01c4f&"
import script from "./VmcUpsell.vue?vue&type=script&lang=js&"
export * from "./VmcUpsell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports